import { useState, useEffect } from "react";
import "./banner-redesigned.css";

const BannerRedesigned = ({ banner2Data, mobileBanner2Data }) => {
  const [isMobile, setIsMobile] = useState(false);

  // Detect screen size
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Use mobile banner if available and on mobile, otherwise use desktop banner
  const activeBanner = isMobile && mobileBanner2Data ? mobileBanner2Data : banner2Data;

  // If no banner data, don't display anything
  if (!activeBanner) {
    return null;
  }

  return (
    <section className="banner-section-redesigned">
      <div className="banner-full-container">
        <img
          src={activeBanner.image?.url}
          alt={activeBanner.title || "Banner"}
          className="banner-full-image"
          onClick={() => {
            if (activeBanner.url) {
              window.location.href = activeBanner.url;
            }
          }}
          style={{ cursor: activeBanner.url ? "pointer" : "default" }}
        />
      </div>
    </section>
  );
};

export default BannerRedesigned;
